import { Tooltip } from 'antd';
import classNames from 'classnames';
import type { ReactNode } from 'react';

import '../Cells.scss';

import type { CellIconProps } from './CellIcon';
import { CellIcon } from './CellIcon';

type ReadOnlyCellProps = {
  value: number | boolean | string;
  descriptionValue?: number | string | ReactNode;
  iconParameters?: CellIconProps;
  name?: string;
  tooltipMessage?: ReactNode;
};

export const ReadOnlyCell = ({
  value,
  iconParameters,
  descriptionValue,
  tooltipMessage,
}: ReadOnlyCellProps) => {
  return (
    <>
      <Tooltip placement="top" title={tooltipMessage || null}>
        <div className={classNames('inventory-cell', 'readonly')}>
          {value}
          {descriptionValue !== undefined && (
            <span className="description">{descriptionValue}</span>
          )}
        </div>
      </Tooltip>

      {!!iconParameters && (
        <CellIcon
          iconColor={iconParameters.iconColor}
          showIcon={iconParameters.showIcon}
          iconType={iconParameters.iconType}
          autoCell={iconParameters.autoCell}
          openingInLastMinuteAutoDiscountRange={
            iconParameters.openingInLastMinuteAutoDiscountRange
          }
        />
      )}
    </>
  );
};
